// angular import
import { Component, input, Input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared/shared-module';

// project import

@Component({
  selector: 'app-nav-logo',
  imports: [SharedModule, RouterModule],
  templateUrl: './nav-logo.html',
  styleUrls: ['./nav-logo.scss']
})
export class NavLogo {
  // public props
  @Input() navCollapsed: boolean;
  NavCollapse = output();
  menuState = input<'expanded' | 'collapsed' | 'hovered'>();
  windowWidth = window.innerWidth;

  // public method
  navCollapse() {
    if (this.windowWidth >= 992) {
      this.navCollapsed = !this.navCollapsed;
      this.NavCollapse.emit();
    }
  }
}
